
  import { Debounce } from '@/utils/decorators'
  import { fixPrice } from '@/utils/general'
  import dayjs from 'dayjs'
  import Vue from 'vue'
  import Component from 'vue-class-component'
  import { Prop, Watch } from 'vue-property-decorator'

@Component({})
  export default class ReserveReport extends Vue {
  @Prop() reports
  executives = []
  reportsAttribute = []
  fixPrice = fixPrice
  dayjs = dayjs
  utcOffset = dayjs().utcOffset()

  filterByExecutive (executive) {
    return this.reportsAttribute.filter(report =>
      report.executiveName === executive
    )
  }

  getData () {
    if (!this.reports) return
    const reports = this.reports.getReserveFinancialReport
    if (!reports) return
    this.reportsAttribute = reports

    const executives = []
    reports.forEach(report => {
      if (!executives.includes(report.executiveName)) {
        executives.push(report.executiveName)
      }
    })
    this.executives = executives
  }

  get totalUtility () {
    let count = 0
    this.reportsAttribute.forEach(report => count += report.utility)
    return count
  }

  get totalStockCost () {
    let count = 0
    this.reportsAttribute.forEach(report => {
      count += Number(report.totalCost)
    })
    return count
  }

  get totalSalePrice () {
    let count = 0
    this.reportsAttribute.forEach(report => {
      count += Number(report.agreedPrice)
    })
    return count
  }

  @Watch('reports', { immediate: true, deep: true })
  @Debounce(500)
  onReportsChange () {
    this.getData()
  }
  }

